import CONSTANTS from '../../constants';
import CacheService from '../../services/cacheService';
const initialState = CacheService.getToken() ? { loggedIn: true, token: CacheService.getToken().token, bname: CacheService.getToken().bname } : {};

export function login(state = initialState, action) {
	switch (action.type) {
		case CONSTANTS.ACTIONS.LOGIN.SUCCESS:
			return {
				loggedIn: true,
				token: action.token,
				bname: action.bname
			};

		case CONSTANTS.ACTIONS.LOGIN.FAILURE:
			return {};
		case CONSTANTS.ACTIONS.LOGOUT:
			return {};
		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/reducers/sessions/loginReducer.js